<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><a id="page-27"></a><span href="#/toc#toc-chapter011" title="Link target outside of Sample">Chapter 11</span></h1>
<h1 class="chapter-title"><span href="#/toc#toc-chapter011" title="Link target outside of Sample">Learning Is the Path to Self-Knowledge</span></h1>
<p class="noindent">The four greatest killers the world has ever seen have come to town.</p>
<p>Sharon Li doesn’t realise this and, frankly, why should she? There’s a lot of stuff out there for one girl to know, especially a shaman who’s expected to know so much stuff it’s a miracle she can remember any one thing at a given moment. And would she really want to know about this? Because Derek doesn’t.</p>
<p class="space-break">Derek, high social secretary, and quite possibly high priest, of the Friendlies, servant of the Lonely Lady, watchman of 4 a.m. and, as if that wasn’t enough, moderately successful owner of a tool hire business operating out of Balham (third off the price if all items are returned on the same working day) says, “Who’s there?”</p>
<p>And then he sees.</p>
<p>“How’d you get here?” he asks, already knowing the answer but feeling he ought to keep the conversation going just in case. “What do you want?”</p>
<p>These are redundant questions, as he knows perfectly well what they want and, more to the point, that he’ll be unable to give it to them. Not through lack of trying, but because truly he does not know the answer to the question, the inevitable question:</p>
<p>“Where is she?”</p>
<p><a id="page-28"></a>He hopes the honesty shows in his face as he answers, backing towards the furthest wall. “I don’t know.”</p>
<p>The four greatest killers in the world didn’t knock, didn’t jingle, didn’t rattle, didn’t crash, didn’t jar, didn’t crunch on their way in, and now, as they move, they make no sound except the quiet mantra that is their murderous chant.</p>
<p>“Come on, pal…”</p>
<p>“Mate…”</p>
<p>“Mucker…”</p>
<p>“Where’s the lady hiding?”</p>
<p>“Are you going to kill me?” Derek asks, or rather, the part of him that desperately wants to live and which, regardless of everything that common sense predicts for the next five minutes, still hopes to explore this receding option.</p>
<p>“Kill you?” one asks.</p>
<p>“Us?” one exclaims.</p>
<p>“Wanker,” offers a third.</p>
<p>“Tosser,” agrees the fourth.</p>
<p>“Why’d we do that, mate? You think we’re that kinda guys?”</p>
<p>“Gotta look out for that, mate.”</p>
<p>“Just give us what we want…”</p>
<p>“Tits!”</p>
<p>Derek’s eyes dance to the one who makes this rather incongruous contribution to the conversation and see him smile. His smile is lecherous, his smile is the ogling grin of a man who’s spent too much time in high places observing the things that pass below, his smile is the smile God would have worn when enjoying a dirty joke with Satan, just you and me, hate the attitude, love the wit. Then his eyes move to the other three in the room. How they entered he does not know, but how they will leave he can fairly guess, and he sees that they too are smiling.</p>
<p>Four faces…</p>
<p>… but all the same smile.</p>
<p>A whimper escapes him before he can prevent it; his fingers scratch into the brick wall at his back. “Please…” he whines. “Please, I don’t know. She’s just vanished, that’s all, she just disappeared!”</p>
<p>“How’d she do that then?” asks one.</p>
<p><a id="page-29"></a>“Magic!” suggests another.</p>
<p>“Poof–farts–poof!” cackles a third.</p>
<p>“Right stinker,” concurs the fourth.</p>
<p>“If you can’t help us…”</p>
<p>“… then we’ll have to find someone else…”</p>
<p>“… because our guvnor…”</p>
<p>“… he wants her so bad…”</p>
<p>“… so bad I mean it’s like he’s got this massive thing…”</p>
<p>“Wanker!”</p>
<p>“Arse.”</p>
<p>“Lovely pair of knockers.”</p>
<p>“So you see…”</p>
<p>Four faces fill his world, four faces and they are all the same face, the same smile, the same eyes, the same voice, whispering their words as the floor cracks beneath his feet and the walls grow fingers of mortar and dust to wrap around his throat and dig into his skin.</p>
<p>“… we ain’t never gonna stop…”</p>
<p>“Overtime, yeah.”</p>
<p>“Payday!”</p>
<p>“… until you give us Greydawn.”</p>
<p>He tries to scream, but the concrete is already giving way beneath him, sucking him down, and the walls have curled their ragged fingers around his face, stopping his mouth with mortar and dirt, filling his throat, his lungs, with thick grey sludge, and still he tries, and no sound can emerge until he is bursting from the inside out with the weight of it and his eyes dribble tar and his face is red, then scarlet, then purple, then the orange-brown of sandstone and clay, and at the very, very last a tiny puff of air escapes his lips, the very last puff that he shall ever breathe, and if you listen closely, if you crane your ear right up next to his face, before it is pulled down into the foundations at his feet, you might hear this one word:</p>
<p><em>Howl.</em></p>
<p>Before he is sucked down beneath the street.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter011.vue?0e09c512